import type { RoomView } from "@grundbesitz/shared";
import { AppHeader } from "../components/AppHeader";
import { LobbyBar } from "../components/lobby/LobbyBar";
import { LobbyChat } from "../components/lobby/LobbyChat";
import { MemberList } from "../components/lobby/MemberList";
import { OptionsPanel } from "../components/lobby/OptionsPanel";
import { RoomHeader } from "../components/lobby/RoomHeader";
import { SeatEditor } from "../components/lobby/SeatEditor";

export function Lobby({ room }: { room: RoomView }) {
  const meId = room.you.playerId;
  const me = room.members.find((m) => m.id === meId) ?? null;
  const isHost = room.you.isHost;

  return (
    <div className="flex min-h-dvh flex-col">
      <AppHeader />
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 pb-32 sm:px-6">
        <RoomHeader code={room.code} />
        <div className="grid gap-x-12 gap-y-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,26rem)]">
          <div className="min-w-0 space-y-10">
            <MemberList members={room.members} meId={meId} isHost={isHost} />
            {me ? (
              <SeatEditor me={me} members={room.members} />
            ) : (
              <section aria-labelledby="watch-title">
                <h2 id="watch-title" className="font-display text-xl font-semibold text-ink">
                  Du schaust zu
                </h2>
                <p className="mt-2 max-w-prose text-ink-2">
                  Du bist in diesem Raum keinem Platz zugeordnet. Sobald der Host das Spiel startet, siehst du die Partie live.
                </p>
              </section>
            )}
          </div>
          <div className="min-w-0 space-y-10">
            <OptionsPanel options={room.options} editable={isHost} />
            <LobbyChat room={room} />
          </div>
        </div>
      </main>
      <LobbyBar members={room.members} me={me} isHost={isHost} />
    </div>
  );
}
